import EMPLOYER_GUARD from '@/core/guards/employer.guard';
import VALID_ON_FILTER_GUARD from '@/core/guards/valid-on-filter.guard';
import { RouteRecordRaw } from 'vue-router';

const customerGroupRoutes: Array<RouteRecordRaw> = [
   {
      path: '',
      name: 'CustomerGroupsOverview',
      component: () => import('@/modules/customer-groups/pages/CustomerGroupsOverview.vue'),
   },
   {
      path: ':id',
      name: 'CustomerGroupDetails',
      component: () => import('@/modules/customer-groups/pages/CustomerGroupDetails.vue'),
      meta: { skipTitleGuard: true },
      redirect: { name: 'CustomerGroupCustomers' },
      children: [
         {
            alias: '',
            path: 'customers',
            name: 'CustomerGroupCustomers',
            component: () => import('@/modules/customer-groups/components/customer-group-details/customers/CustomerGroupCustomers.vue'),
         },
         {
            path: 'cooperation-agreements',
            name: 'CustomerGroupCooperationAgreements',
            beforeEnter: [EMPLOYER_GUARD],
            component: () =>
               import('@/modules/customer-groups/components/customer-group-details/cooperation-agreements/CustomerGroupCooperationAgreements.vue'),
         },
         {
            path: 'commercial-agreements',
            name: 'CustomerGroupCommercialAgreements',
            component: () =>
               import('@/modules/customer-groups/components/customer-group-details/commercial-agreements/CustomerGroupCommercialAgreements.vue'),
            beforeEnter: [
               EMPLOYER_GUARD,
               VALID_ON_FILTER_GUARD,
               (to, from, next) => {
                  if (to.query.hide_general_co !== undefined) return next();
                  return next({ ...to, query: { ...to.query, hide_general_co: 1 } });
               },
            ],
         },
      ],
   },
];

export default customerGroupRoutes;
